import { render, staticRenderFns } from "./archived_badge.vue.js?vue&type=template&id=9f1d0fae!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./archived_badge.vue?vue&type=template&id=9f1d0fae"
import script from "./archived_badge.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./archived_badge.vue?vue&type=script&lang=js"
export * from "./archived_badge.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./archived_badge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports